
  import { Vue, Component, Prop } from "vue-property-decorator";
  import Modal from "./";
  import { UserService } from "@/services";
  import { Utils } from "@/helper";

  @Component({
    name: "LoginModal"
  })
  export default class LoginModal extends Vue {
    publicPath: string = process.env.BASE_URL as string;
    visible: boolean = false;
    beforeMount() {
      Modal.event.$on("show", this.show);
    }
    getImagePath(path: string) {
      return `${this.publicPath}${path}`;
    }
    show() {
      this.visible = true;
    }
    close() {
      this.visible = false;
    }
    async authorize() {
      this.$mainLoader.show();
      let cookies = null;
      let secure = null;
      // if already login on root  website
      // then don't force to relogin
      if (process.env.NODE_ENV === "production") {
        switch (window.location.host) {
          case "dev.vin.com":
            cookies = this.$cookies.get("VIN.Security.Dev");
            secure = this.$cookies.get(".VINSecRoleDEV");
            break;
          case "qa.vin.com":
            cookies = this.$cookies.get("VIN.Security.QA");
            secure = this.$cookies.get(".VINSecRoleQA");
            break;
          case "www.vin.com":
            cookies = this.$cookies.get("VIN.Security.Live");
            secure = this.$cookies.get(".VINSecRoleLive");
            break;
        }
      }

      let force = false;
      if (cookies !== null) {
        force = false;
      } else if (secure !== null) {
        force = false;
      } else {
        force = true;
      }

      let response = await UserService.GetAuthorizeUrl(force);
      this.$mainLoader.hide();

      if (response.status === 200) {
        // window.location.replace(response.result)
        this.showAuthorizePopup(response.data);
      }
      this.visible = false;
    }
    showAuthorizePopup(url: string) {
      // comment: Utils.ShowPopup(url, "VIN Login", 700, 500, "yes");
      localStorage.setItem("last_url", window.location.href);
      window.location.assign(url);
    }
  }
